import { render, staticRenderFns } from "./DocumentTemplateCreateModal.vue?vue&type=template&id=72aa2714&"
import script from "./DocumentTemplateCreateModal.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports